/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Iceutility } from '../../services/iceutility';
import { assetjournal } from '../accounting/assetjournal';
import { incomerevenuejournal } from '../accounting/incomerevenuejournal';
import { basecode } from '../ehr/subs/basecode';
import { medicationactivity } from '../ehr/subs/medicationactivity';
import { reviewer } from '../ehr/subs/reviewer';
import { IceTypes } from '../icetypes';
import { accountingsummary } from '../stats/accountingsummary';
import { antenatalattendancestat } from '../stats/antenatalattendancestat';
import { appointmentstat } from '../stats/appointmentstat';
import { labordeliverystat } from '../stats/labordeliverystat';
import { patientstat } from '../stats/patientstat';
import { pharmacystat } from '../stats/pharmacystat';
import { providerstat } from '../stats/providerstat';
import { viralstat } from '../stats/viralstat';
import { report, reportDataField } from './report';

export class reportdata extends report {
  public report_key: string = "";
  public collection_status: number = 0.0;

  ANTENATAL_ATTENDANCE_STAT: antenatalattendancestat[] = [];
  LABOR_DELIVERY_STAT: labordeliverystat[] = [];
  PATIENTSTATS: patientstat[] = [];
  PROVIDERSTATS: providerstat[] = [];
  PHARMACYSTATS: pharmacystat[] = [];
  VIRAL_STAT: viralstat[] = [];
  ACCOUNTING_SUMMARY: accountingsummary[] = [];
  SERVICESTATS: accountingsummary[] = [];
  REVIEWS: reviewer[] = [];
  REVENUES: incomerevenuejournal[] = [];
  REVENUES_FROM_AR: assetjournal[] = [];
  GENERALCODES: basecode[] = [];

  public gettablename(): string {
    return "REPORT_DATA";
  }

  public hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return true;
    else if (ColumnName == "LABOR_DELIVERY_STAT") return true;
    else if (ColumnName == "PATIENTSTATS") return true;
    else if (ColumnName == "PROVIDERSTATS") return true;
    else if (ColumnName == "PHARMACYSTATS") return true;
    else if (ColumnName == "VIRAL_STAT") return true;
    else if (ColumnName == "ACCOUNTING_SUMMARY") return true;
    else if (ColumnName == "SERVICESTATS") return true;
    else if (ColumnName == "REVIEWS") return true;
    else if (ColumnName == "REVENUES") return true;
    else if (ColumnName == "REVENUES_FROM_AR") return true;
    else if (ColumnName == "GENERALCODES") return true;

    return false;
  }

  public getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "ANTENATAL_ATTENDANCE_STAT") return "ANTENATAL_ATTENDANCE_STAT";
    else if (ColumnName == "LABOR_DELIVERY_STAT") return "LABOR_DELIVERY_STAT";
    else if (ColumnName == "PATIENTSTATS") return "PATIENT_STAT";
    else if (ColumnName == "PROVIDERSTATS") return "PROVIDER_STAT";
    else if (ColumnName == "PHARMACYSTATS") return "PHARMACY_STAT";
    else if (ColumnName == "VIRAL_STAT") return "VIRAL_STAT";
    else if (ColumnName == "ACCOUNTING_SUMMARY") return "ACCOUNTING_SUMMARY";
    else if (ColumnName == "SERVICESTATS") return "ACCOUNTING_SUMMARY";
    else if (ColumnName == "REVIEWS") return "REVIEWER";
    else if (ColumnName == "REVENUES") return "INCOME_REVENUE_JOURNAL";
    else if (ColumnName == "REVENUES_FROM_AR") return "ASSET_JOURNAL";
    else if (ColumnName == "GENERALCODES") return "GENERAL_CODE";

    return null;
  }

  getDataMedActivity(ptstat: patientstat, medActy: medicationactivity, cols: string[]): any[] {
    let record: any[] = [];
    if (cols == null || cols.length == 0) return null;
    if (ptstat == null || medActy == null) return null;
    for (let icol = 0; icol < cols.length; icol++) {
      switch (cols[icol]) {
        case "PROVIDER_STAT.ORGANIZATION_NAME":
        case "PROVIDER_STAT.PREFIX":
        case "PROVIDER_STAT.FIRST_NAME":
        case "PROVIDER_STAT.LAST_NAME":
        case "PROVIDER_STAT.STREET1":
        case "PROVIDER_STAT.STREET2":
        case "PROVIDER_STAT.PHONE_NUM":
        case "PROVIDER_STAT.NPI_NUM":
        case "PROVIDER_STAT.DEA_NUM":
        case "PROVIDER_STAT.CITY":
        case "PROVIDER_STAT.STATE_ID":
        case "PROVIDER_STAT.POSTAL_CODE": {
          let foundProv = this.PROVIDERSTATS.filter(p => p.trans_account == medActy.requester_trans_account);
          if (foundProv.length > 0) {
            let colName = reportDataField.parseColumnName(cols[icol]);
            record[icol] = foundProv[0][colName.toLocaleLowerCase()];
          }
          break;
        }
        case "PHARMACY_STAT.ORGANIZATION_NAME":
        case "PHARMACY_STAT.STREET1":
        case "PHARMACY_STAT.STREET2":
        case "PHARMACY_STAT.CITY":
        case "PHARMACY_STAT.STATE_ID":
        case "PHARMACY_STAT.POSTAL_CODE":
        case "PHARMACY_STAT.PHONE_NUM": {
          let foundPharm = this.PHARMACYSTATS.filter(p => p.trans_account == medActy.pharmacy_key);
          if (foundPharm.length > 0) {
            let colName = reportDataField.parseColumnName(cols[icol]);
            record[icol] = foundPharm[0][colName.toLocaleLowerCase()];
          }
          break;
        }
        case "PATIENT_STAT.FIRST_NAME":
        case "PATIENT_STAT.LAST_NAME":
        case "PATIENT_STAT.DOB":
        case "PATIENT_STAT.STREET1":
        case "PATIENT_STAT.STREET2":
        case "PATIENT_STAT.CITY":
        case "PATIENT_STAT.POSTAL_CODE":
        case "PATIENT_STAT.AGE": {
          let colName = reportDataField.parseColumnName(cols[icol]);
          let data = ptstat[colName.toLocaleLowerCase()];
          if (cols[icol] == "PATIENT_STAT.DOB")
            record[icol] = Iceutility.isTextDateTime(data) ? Iceutility.getDateTextEx(data, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data), null, false);
          else
            record[icol] = data;
          break;
        }
        case "MEDICATION_ACTIVITY.ORDER_ENTRY_KEY":
        case "MEDICATION_ACTIVITY.SYSTEM_ENTRY_DATE":
        case "MEDICATION_ACTIVITY.ACTIVITY_DESCRIPTION":
        case "MEDICATION_ACTIVITY.SIG":
        case "MEDICATION_ACTIVITY.ADMINISTERED_AMOUNT":
        case "MEDICATION_ACTIVITY.ADMINISTERED_UNITS_TEXT":
        case "MEDICATION_ACTIVITY.RX_QUANTITY":
        case "MEDICATION_ACTIVITY.SUBSTITUTION_NOT_ALLOWED":
        case "MEDICATION_ACTIVITY.ORDER_NOTE": {
          let colName = reportDataField.parseColumnName(cols[icol]);
          let data = medActy[colName.toLocaleLowerCase()];
          if (cols[icol] == "MEDICATION_ACTIVITY.SYSTEM_ENTRY_DATE")
            record[icol] = Iceutility.isTextDateTime(data) ? Iceutility.getDateTextEx(data) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data));
          else if (cols[icol] == "MEDICATION_ACTIVITY.SUBSTITUTION_NOT_ALLOWED")
            record[icol] = Iceutility.toBoolean(data) ? "Not Allowed" : "Allowed";
          else
            record[icol] = data;
          break;
        }
      }
    }
    return record;
  }

  getDataSchedule(ptstat: patientstat, appt: appointmentstat, cols: string[]): any[] {
    let record: any[] = [];
    if (cols == null || cols.length == 0) return null;
    if (ptstat == null || appt == null) return null;
    for (let icol = 0; icol < cols.length; icol++) {
      switch (cols[icol]) {
        case "APPOINTMENT.ORGANIZER":
          let parts = appt.provider_keywords != null ? appt.provider_keywords.split(",") : [];
          if (parts.length > 0) {
            // only show the first one
            let foundOrg = this.PROVIDERSTATS.filter(p => p.trans_account == parts[0]);
            if (foundOrg.length > 0) {
              record[icol] = foundOrg[0].getdisplayname(false);
            }
            else {
              record[icol] = "";
            }
          }
          break;
        case "APPOINTMENT.LOCATION":
          let foundLocation = this.PROVIDERSTATS.filter(p => p.trans_account == appt.trans_account);
          if (foundLocation.length > 0) {
            record[icol] = foundLocation[0].getdisplayname(Iceutility.toLong(foundLocation[0].account_type) == IceTypes.ACCOUNT_TYPE.actFacility);
          }
          else {
            record[icol] = "";
          }
          break;
        case "APPOINTMENT.PATIENT_TRANS_ACCOUNT":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_NAME":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_ADDRESS":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_CITY":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_STATE":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_POSTAL_CODE":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_AGE":
          record[icol] = "";
          break;
        case "APPOINTMENT.PATIENT_DOB":
          let dobColName = reportDataField.parseColumnName(cols[icol]);
          let dob = ptstat[dobColName.toLocaleLowerCase()];
          if (cols[icol] == "PATIENT_STAT.DOB")
            record[icol] = Iceutility.isTextDateTime(dob) ? Iceutility.getDateTextEx(dob, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(dob), null, false);
          else {
            record[icol] = "";
          }
          break;
        case "APPOINTMENT.PATIENT_SEX":
          record[icol] = "";
          break;
        case "APPOINTMENT.COMMUNICATION_NUMBER1":
          record[icol] = "";
          break;
        case "APPOINTMENT.COMMUNICATION_NUMBER2":
          record[icol] = "";
          break;
        case "APPOINTMENT.APPOINTMENT_KEY":
        case "APPOINTMENT.APPOINTMENT_TYPE":
        case "APPOINTMENT.APPOINTMENT_STATUS":
        case "APPOINTMENT.TIME_SLOT_START":
        case "APPOINTMENT.TIME_SLOT_END":
        case "APPOINTMENT.SUBJECT": {
          let colName = reportDataField.parseColumnName(cols[icol]);
          let data = appt[colName.toLocaleLowerCase()];
          if (cols[icol] == "APPOINTMENT.TIME_SLOT_START" || cols[icol] == "APPOINTMENT.TIME_SLOT_END")
            record[icol] = Iceutility.isTextDateTime(data) ? Iceutility.getDateTextEx(data) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(data));
          else
            record[icol] = data;
          break;
        }
        case "APPOINTMENT.DATE":
          record[icol] = Iceutility.getDateTextEx(Iceutility.GetLocalDate());
          break;
        case "APPOINTMENT.APPOINTMENT_STATUS_NOTE":
          record[icol] = "";
          break;
        case "APPOINTMENT.MINUTES":
          record[icol] = "";
          break;
        case "APPOINTMENT.REASON_FOR_VISIT":
          record[icol] = "";
          break;
      }
    }
    return record;
  }
}
